export default __webpack_public_path__ + "static/media/Panel_+_Stage1.4bf1a68e.svg";